<template>
  <div class="reading" :style="aqiStyles(reading)">
    {{ validateAQI(reading) }}
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { getAQIStyles, useAqiValidator } from '@/services/map'

export default defineComponent({
  name: 'StyledReading',
  props: {
    reading: {
      type: Number
    },
    aqiType: {
      type: Number,
      default: 0
    },
    measurementType: {
      type: Number,
      default: 0
    }
  },
  setup() {
    const { validateAQI } = useAqiValidator()
    return { validateAQI }
  },
  methods: {
    aqiStyles(aqi: number | null): string {
      const styles = getAQIStyles(aqi ?? -1, this.aqiType, this.measurementType)

      if (styles.background === '#eeeeee') {
        return `background-color:${styles.background};color:#0c0c0cc2;`
      }
      return `background-color:${styles.background};color:${styles.color}`
    }
  }
})
</script>

<style lang="scss" scoped>
.reading {
  background-color: #eeeeee;
  color: white;
  text-align: center;
  font-weight: 500;
  border-radius: 2px;
  width: 40px;
  padding: 2px 0 2px 0;
}
</style>
